import { useField } from 'formik';
import { TextField, TextFieldModel } from 'ui-components';
import React from 'react';
import useStyles from './FormikTextField.style';

const FormikTextField: React.FC<(
    Omit<TextFieldModel, 'name' | 'variant'>)
    & {
      name: string;
      forceShowErrors?: boolean;
      required?: boolean;
      helperText?: string;
      testId?: string;
}> = ({ forceShowErrors, required, helperText, testId, ...props }) => {
  const c = useStyles({});
  const [field, meta] = useField(props.name);
  const fieldError = meta.error;
  const showError = forceShowErrors || (meta.touched && (fieldError !== undefined));
  return <TextField testId={testId || 'text-field'}
                    hasError={showError}
                    className={c.root}
                    required={required}
                    {...field}
                    {...props}
                    error={showError ? fieldError : undefined}
                    helperText={!showError && helperText}
          />;
};

export default FormikTextField;
